export const DefaultDocument = {
    application: "",
    accountGroupName: "",
    active: false,
    contentSizeKB: 0,
    creationDate: "",
    creatorUsername: "",
    fileName: "",
    fileType: "",
    language: "",
    lastDownloadedOn: "",
    lastDownloader: "",
    reportType: "",
    status: "",
    uuid: "",
}